import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { message as messageAntd } from 'antd';
import { registrationTypes } from '../../../../constants/registrationTypes';

const chengeTemplates = async ({
  templateId,
  name,
  message,
  message2,
  serviceCompanyId,
  registrationTypeId,
}) => {
  const objTemplate = {
    Id: templateId,
    Name: name,
    Message: message,
    Message2: message2,
    ServiceCompanyId: serviceCompanyId,
    RegistrationTypeId: registrationTypeId,
  };

  const res = await request.put(
    `/HousingStock/house_access_type`,
    JSON.stringify(objTemplate),
    'Не удалось изменить шаблон'
  );
  return res;
};

const useChengeTemplates = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(chengeTemplates, {
    onSuccess: async (
      data,
      {
        templateId,
        name,
        message,
        message2,
        serviceCompanyId,
        registrationTypeId,
      }
    ) => {
      if (data !== 'Error' && data.success) {
        messageAntd.success('Шаблон успешно изменен', 2);
        queryClient.setQueryData(
          getQueryKeys.templates({ serviceCompanyId, registrationTypeId }),
          (oldData) =>
            oldData.map((oldTemplate) =>
              oldTemplate.id === templateId
                ? Number(registrationTypeId) ===
                  registrationTypes.personalAccounts.id
                  ? { ...oldTemplate, name, message, message2 }
                  : { ...oldTemplate, name, message }
                : oldTemplate
            )
        );
      }
    },
  });

  return {
    chengeAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useChengeTemplates };
